import type { ConnectorAction, ConnectorState } from "./types";

const initialState: ConnectorState = {
  chainId: null,
  accounts: null,
  isConnecting: false,
  error: undefined,
};

function connectorReducer(
  state: ConnectorState,
  action: ConnectorAction
): ConnectorState {
  switch (action.type) {
    case "startConnecting": {
      return { ...state, isConnecting: true };
    }
    case "update": {
      // TODO: check if action has chainId or accounts and validate them
      // before updating state
      const chainId = action.chainId ?? state.chainId;
      const accounts = action.accounts ?? state.accounts;
      let { error, isConnecting } = state;

      // Clear error if appropriate
      if (error && accounts && chainId) {
        error = undefined;
      }

      // Clear isConnecting if appropriate
      if (isConnecting && (error || (accounts && chainId))) {
        isConnecting = false;
      }

      return { accounts, chainId, error, isConnecting };
    }
    case "error": {
      return { ...initialState, error: action.error };
    }
    case "reset": {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export { connectorReducer, initialState };
